<template>
<!-- <div class="about-our">
  <div class="col-xs-12 col-sm-12 col-md-8 circle-wrap" style="position: relative">
    <img class="circle-img" src="../assets/untitled-10.png">
  </div>
  <div class="col-xs-12 col-sm-12 col-md-12" style="display: inline-flex;">
    <div class="about-our-left col-xs-12 col-sm-12 col-md-4">
      <img class="app-img" src="../assets/untitled-8.png">
    </div>
    <div class="about-our-info col-xs-12 col-sm-12 col-md-8">
      <ul>
        <li><span class="circle"></span><b class="about-our-bolder">注册与入驻：</b><span class="about-our-size">酒店和人力工资进行入驻信息填写和员工注册，管理员工基本信息。</span></li>
        <li><span class="circle"></span><b class="about-our-bolder">保洁流程管理：</b><span class="about-our-size">从派工、派单、保洁、验收进行酒店保洁线上全流程管理。</span></li>
        <li><span class="circle"></span><b class="about-our-bolder">对账与结算：</b><span class="about-our-size">系统每日、月生成对账单，进行保洁工单的核对，无需纸质核对，系统记录交易一目了然。</span></li>
        <li><span class="circle"></span><b class="about-our-bolder">培训与考试：</b><span class="about-our-size">所有酒店保洁员工经过专业，体系的保洁课程培训和考试，合格者上岗保洁。</span></li>
      </ul>
    </div>
  </div>
</div> -->
  <div class="carousel-wrap height">
    <div class="circle-wrap">
      <div class="circle-wrap">
        <img class="circle-img" src="../assets/untitled-10.png">
      </div>

      <div class="flex-center" style="margin-top: 30px;">
        <div class="about-our-left col-xs-6 col-sm-6 col-md-6  flex-end">
          <img class="app-img" src="../assets/untitled-8.png">
        </div>
        <div class="about-our-info col-xs-6 col-sm-6 col-md-6">
          <ul>
            <li><span class="circle"></span><b class="about-our-bolder">注册与入驻：</b><span class="about-our-size">酒店和人力工资进行入驻信息填写和员工注册，管理员工基本信息。</span></li>
            <li><span class="circle"></span><b class="about-our-bolder">保洁流程管理：</b><span class="about-our-size">从派工、派单、保洁、验收进行酒店保洁线上全流程管理。</span></li>
            <li><span class="circle"></span><b class="about-our-bolder">对账与结算：</b><span class="about-our-size">系统每日、月生成对账单，进行保洁工单的核对，无需纸质核对，系统记录交易一目了然。</span></li>
            <li><span class="circle"></span><b class="about-our-bolder">培训与考试：</b><span class="about-our-size">所有酒店保洁员工经过专业，体系的保洁课程培训和考试，合格者上岗保洁。</span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutOur",
    data() {
      return {
        style: ''
      }
    },
    methods:{
    },
    mounted() {
      this.style = `height:${window.innerHeight -60}px;`
    },
  }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/index.scss';
  @media screen and (min-width:0px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 870px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      // /*height: 600px;*/
      height: calc(100vh - 60px);
    }
  }

  @media screen and (max-width: 768px) {
    // .height{
    //   height: 730px;
    // }
    .carousel-wrap{
      // height: 730px;
      // height: 730px;
      background: url('../assets/untitled-3.png')no-repeat;
      background-size: 100% 100%;
      padding-top: 100px;
    }
    .circle-wrap{
      width: 100%;
    }
    .app-img{
      @include px2rem(width, 260);
    }
    .circle-img{
      width: 80%;
    }
    .about-our-info li{
      width: 90%;
      float: left;
      color: #ffffff;
      text-align: left;
      border: 1px dashed #fff;
      padding: 20px 6px;
      @include px2rem(border-radius, 14);
      list-style-type: none;
      @include px2rem(margin-bottom, 28);
    }
    .about-our-left{
      // padding-right: 100px;
    }
  }
  @media screen and (min-width: 768px) {

      .carousel-wrap{
        width: 100%;
        background: url('../assets/untitled-3.png')no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .circle-wrap{
        width: 100%;
      }
      .app-img{
        @include px2rem(width, 260);
      }
      .circle-img{
        width: 50%;
      }
      .about-our-info li{
        width: 60%;
        float: left;
        color: #ffffff;
        text-align: left;
        border: 1px dashed #fff;
        padding: 20px 6px;
        @include px2rem(border-radius, 14);
        list-style-type: none;
        @include px2rem(margin-bottom, 28);
      }
      .about-our-left{
        padding-right: 100px;
      }
  }
  .about-our-bolder{
    @include px2rem(font-size, 22);
  }





































  // .about-our{
  //   width: 100%;
  //   background: url("../assets/untitled-3.png");
  //   background-size: 100% 100%;
  //   /*display: flex;*/
  //   justify-content: center;
  //   align-items: center;
  // }

  // @media screen and (max-width: 768px){
  //   .about-our{
  //     height: 800px;
  //     background: url('../assets/untitled-3.png')no-repeat;
  //     background-size: 100% 100%;
  //   }
  // }
  // @media screen and (min-width: 768px) {
  //   .about-our{
  //     width: 100%;
  //     height: calc(100vh - 60px);
  //     background: url("../assets/untitled-3.png");
  //     background-size: 100% 100%;
  //     /*display: flex;*/
  //     justify-content: center;
  //     align-items: center;
  //   }
  // }
  // @media screen and (min-width: 768px){
  //   .app-img{
  //     @include px2rem(width, 380);
  //     /*<!--@include px2rem(height, 688);-->*/
  //     margin-top: 50px;
  //     margin-bottom: 100px;
  //     /*width: 220px;
  //        height: 442px;*/
  //   }
  // }

  // @media screen and (max-width: 768px) {
  //   .app-img{
  //     width: 100px;
  //     /*height: 350px;*/
  //     margin-bottom: 0px;
  //     margin-top: 240px;
  //   }
  // }
  // @media screen and (min-width: 768px)  {
  //   .about-our-left{
  //     @include px2rem(width, 360);
  //     @include px2rem(height, 688);
  //     float: left;
  //     margin-left: 160px;
  //     /* width: 220px;
  //      height: 442px;*/
  //     @include px2rem(margin-right, 42);
  //     /*margin-right: 30px;*/
  //   }
  // }

  // @media screen and (max-width: 768px) {
  //   .about-our-left{
  //     width: 50px;
  //     height: 150px;
  //     margin-left: 0px;
  //   }
  // }
  // .about-our-right{
  //   @include px2rem(width, 963);
  //   /*width: 700px;*/
  // }
  // @media screen and (min-width: 768px) {
  //   .circle-img {
  //     /* @include px2rem(width, 963);
  //   @include px2rem(height, 165);*/
  //     width: 70%;
  //     /*height: 100px;*/
  //     margin-top: 10px;
  //     position: absolute;
  //     left: 500px;
  //     top: 20px;
  //     /*margin-left: 500px;*/
  //     margin-bottom: 20px;
  //     /*width: 700px;
  //     height: 120px;*/
  //   }
  // }
  // @media screen and (max-width: 768px){
  //   .circle-img{
  //     width: 90%;
  //     /*height: 90px;*/
  //     margin-left: 0px;
  //     position: absolute;
  //     left: 20px;
  //     top: 120px;
  //   }
  // }
  // @media screen and (min-width: 768px)  {
  //   .about-our-info{
  //     margin-top: 170px;
  //   }
  // }
  // @media screen and (max-width: 768px) {
  //   .about-our-info {
  //     margin-top: 230px;
  //   }
  // }
  // @media screen and (min-width: 768px) {
  //   .about-our-info li{
  //     width: 60%;
  //     margin-left: 60px;
  //     float: left;
  //     color: #ffffff;
  //     text-align: left;
  //     border: 1px dashed #fff;
  //     @include px2rem(margin-bottom, 28);
  //     /*margin-bottom: 20px;*/
  //     padding: 20px 6px;
  //     @include px2rem(border-radius, 14);
  //     /*border-radius: 10px;*/
  //     list-style-type: none;
  //     @include px2rem(margin-top, 28);
  //     /*margin-top: 20px;*/
  //   }
  // }

  // @media screen and (max-width: 768px) {
  //   .about-our-info li{
  //     margin-left: 60px;
  //     float: left;
  //     color: #ffffff;
  //     text-align: left;
  //     border: 1px dashed #fff;
  //     @include px2rem(margin-bottom, 10);
  //     /*margin-bottom: 20px;*/
  //     padding: 6px 6px;
  //     @include px2rem(border-radius, 14);
  //     /*border-radius: 10px;*/
  //     list-style-type: none;
  //     @include px2rem(margin-top, 10);
  //     /*margin-top: 20px;*/
  //   }
  // }
  // .about-our-bolder{
  //   @include px2rem(font-size, 22);
  //   /*font-size: 16px;*/
  // }
  // .about-our-size{
  //   @include px2rem(font-size, 18);
  //   /*font-size: 13px;*/
  // }
  // .circle{
  //   display: inline-block;
  //   @include px2rem(width, 9);
  //   @include px2rem(height, 9);
  //  /* width: 6px;
  //   height: 6px;*/
  //   border-radius: 50%;
  //   background: #fff;
  //   @include px2rem(margin-right, 14);
  //   /*margin-right: 10px;*/
  // }
</style>



// WEBPACK FOOTER //
// src/components/AboutOur.vue